import GlobalHelper from "../../common/GlobalHelper.jsx"
import { SearchPayload } from "../../state/search/SearchPayload"


export const generateContactSearchParams = (searchParams?: Partial<SearchPayload>): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? ""),
        objects: searchParams?.objects ?? ["contacts"],
        fields: ["name", "nameAnalyzed", "nameKeyword", "nameSort", "email", "emailKeyword"],
        filters: {
            contactType: searchParams?.filters?.contactType ?? "persons",
            emailKeyword: searchParams?.filters?.emailKeyword ?? "{exists};"
        },
        pageSize: searchParams?.pageSize ?? 50,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "nameSort",
        sortAsc: searchParams?.sortAsc ?? true,
        lightResult: searchParams?.lightResult ?? true
    }
}

/*
 ** Eventually move to a seprate file maybe called searchPayload
 */

export const generateInventoryAdjustmentsSearchParams = (searchParams?: Partial<SearchPayload>): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? "*"),
        objects: searchParams?.objects ?? ["inventory-adjustment"],
        fields: searchParams?.fields ?? [],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 25,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "createdAt",
        sortAsc: searchParams?.sortAsc ?? true,
        lightResult: searchParams?.lightResult ?? true
    }
}

export const generateInventoryReservationsSearchParams = (searchParams?: Partial<SearchPayload>): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? "*"),
        objects: searchParams?.objects ?? ["stock-document-lines", "order-lines"],
        fields: searchParams?.fields ?? [],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 25,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "createdAt",
        sortAsc: searchParams?.sortAsc ?? true,
        lightResult: searchParams?.lightResult ?? true
    }
}

export const generateInventoryInTransitSearchParams = (searchParams?: Partial<SearchPayload>): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? "*"),
        objects: searchParams?.objects ?? ["stock-document-lines"],
        fields: searchParams?.fields ?? [],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 25,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "createdAt",
        sortAsc: searchParams?.sortAsc ?? true,
        lightResult: searchParams?.lightResult ?? true
    }
}

/*
 ** Generate default select option based on mutilple or single select
 */
export const generateDefaultSelection = (isMultipleSelect: boolean): Array<undefined> | undefined => {
    return isMultipleSelect ? [] : undefined
}

export const generateSerialNumberSearchParams = (
    searchParams?: Partial<SearchPayload>
): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? ""),
        objects: searchParams?.objects ?? ["serial-numbers"],
        fields: ["serial", "serialAnalyzed"],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 50,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "createdAt",
        sortAsc: searchParams?.sortAsc ?? false,
        lightResult: searchParams?.lightResult ?? true
    }
}

export const generateProductsByPriceLevelSearchParams = (
    searchParams?: Partial<SearchPayload>
): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? ""),
        objects: searchParams?.objects ?? ["product-prices"],
        fields: ["priceLevelId", "serialAnalyzed"],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 10,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "price",
        sortAsc: searchParams?.sortAsc ?? true,
        lightResult: searchParams?.lightResult ?? true
    }
}

export const generateProductSearchParams = (
    searchParams?: Partial<SearchPayload>
): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? ""),
        objects: searchParams?.objects ?? ["products"],
        fields: ["title", "titleKeyword", "titleAnalyzed", "titleSort", "sku", "skuKeyword",
            "manufacturerSkuText", "manufacturerSkuKeyword", "skuText", "upc", "ean", "barcode"],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 10,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "titleSort",
        sortAsc: searchParams?.sortAsc ?? true,
        lightResult: searchParams?.lightResult ?? true
    }
}

export const generateStockDocumentSearchParams = (
    searchParams?: Partial<SearchPayload>
): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? ""),
        objects: searchParams?.objects ?? ["inventory-stock-documents"],
        fields: [],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 10,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "identifierInteger",
        sortAsc: searchParams?.sortAsc ?? false,
        lightResult: searchParams?.lightResult ?? true,
        totals: searchParams?.totals ?? []
    }
}

export const generateOrderLineSearchParams = (
    searchParams?: Partial<SearchPayload>
): SearchPayload => {
    return {
        keywords: GlobalHelper.formatSearchKeywords(searchParams?.keywords ?? ""),
        objects: searchParams?.objects ?? ["order-lines"],
        fields: [
            "orderIdentifier",
            "orderIdentifierAnalyzed",
            "orderIdentifierKeyword",
            "orderIdentifierNumber",
            "contact.name",
            "contact.nameAnalyzed",
            "contact.nameSort",
            "contact.email",
            "contact.emailKeyword",
            "contact.firstName",
            "contact.firstNameKeyword",
            "contact.lastName",
            "contact.lastNameKeyword" ,
            "productTitle",
            "productTitleAnalyzed",
            "productTitleKeyword",
        ],
        filters: searchParams?.filters ?? {},
        pageSize: searchParams?.pageSize ?? 5,
        activePage: searchParams?.activePage ?? 1,
        sortByField: searchParams?.sortByField ?? "createdAt",
        sortAsc: searchParams?.sortAsc ?? false,
        lightResult: searchParams?.lightResult ?? true,
        totals: searchParams?.totals ?? []
    }
}


// WEBPACK FOOTER //
// ./src/utils/search/utils.ts